export default {
  LOAD_STUDY_PLAN_CYCLE_LIST_START: 'LoadStudyPlanCycleListStart',
  LOAD_STUDY_PLAN_CYCLE_LIST_END: 'LoadStudyPlanCycleListEnd',
  TOGGLE_STUDY_PLAN_CYCLE_LIST_CONFIRM_DIALOG: 'ToggleStudyPlanCycleListConfirmDialog'
};